module.exports = __webpack_public_path__ + "static/przed-pensjonatem-zima-c5fcba0d68af2ed340f9a3b402005d50.jpg";